import {
  TRANSACTION_COUNT_FETCH_REQUEST,
  TRANSACTION_COUNT_FETCH_REQUEST_SUCCESS,
  TRANSACTION_COUNT_FETCH_REQUEST_FAILURE,
  TRANSACTION_COUNT_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const transactionCountsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_COUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_COUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TRANSACTION_COUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TRANSACTION_COUNT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default transactionCountsReducer;
